export default __webpack_public_path__ + "static/media/KevserTanrikulu.ab3838d4.png";